import React, { useEffect } from 'react'
import { isEmpty } from 'ramda'

import ENV_VARS from '@/config'
import useCurrentSession from '@/hooks/use-current-session'
import { useHasListings } from '@/hooks/use-has-listings'

import { useDSLogin } from '../Auth/Context/ds-login-provider'
import PostAListing from '../post-a-listing'

const { DASHBOARD_URL } = ENV_VARS

const BoostAListing = () => {
  const session = useCurrentSession()

  const { hasListings } = useHasListings()
  const { afterLoginRef } = useDSLogin()

  // Redirects for tour

  useEffect(() => {
    if (afterLoginRef.current) return
    if (!isEmpty(session) && session?.id) {
      if (session?.user_type === 'tenant') {
        window.location.href = `${DASHBOARD_URL}/rentals?rw=1`
      } else {
        if (hasListings?.message) {
          // Has at least 1 listing ( Draft, Managed, Published, Pending, Hidden, etc... )
          window.location.href = `${DASHBOARD_URL}/listings`
        } else {
          // Has NO listings
          window.location.href = `${DASHBOARD_URL}/listing/create/`
        }
      }
    }
  }, [session])

  // Localstate flag for sponsored - tour

  useEffect(() => {
    try {
      if ('localStorage' in window && window['localStorage'] !== null) {
        // Local storage is available
        const tourData = {
          propertyType: false,
          listingDetails: false,
          boostListing: false,
          publishListing: false,
          listingDashboard: false
        }
        localStorage.setItem('sponsored-tour', JSON.stringify(tourData))
      } else {
        // Local storage is not available
        console.log(
          'Localstorage not available. Please check your browser settings.'
        )
      }
    } catch (e) {
      // An error occurred while accessing local storage
    }
  }, [])

  return <PostAListing pageType="boost-a-listing" />
}

export default BoostAListing
